module.exports = "<div class=\"cgp-mdp-title-el-wrapper\">\n    {titleEl | inject}\n</div>\n";